import { useTranslation } from "react-i18next";

import { Card, CardContent } from "@/components/ui/card";

import { formatNumber, getCurrencySymbolFromCache } from "../../../../utils";
import { getLocalisedName } from "../../../../utils/i18n";
import { formatUnitPrice } from "../../../RepresentativeOffers/utils";
import { Deposit } from "../deposit-dtos";
import { formatDepositDate } from "../../utils";

export const DepositSummary = ({ deposit }: { deposit: Deposit }) => {
  const { t } = useTranslation();

  if (!deposit) {
    return null;
  }

  const unitCode = deposit.unit_of_measure?.code;
  const currencySymbol = getCurrencySymbolFromCache() ?? "";

  const details: { label: string; value: string }[] = [
    {
      label: "commodityName",
      value: getLocalisedName(
        deposit.farmer_produce?.commodity || deposit.commodity || "Unknown commodity"
      ),
    },
    { label: "depositQuality", value: deposit.quality_grade?.name || "Unknown quality" },
    {
      label: "depositQuantity",
      value: unitCode ? `${formatNumber(deposit.quantity)} ${unitCode}` : "",
    },
    {
      label: "depositPrice",
      value: unitCode ? formatUnitPrice(deposit.price, currencySymbol, unitCode) : "",
    },
  ];

  return (
    <Card className="gap-0 py-0">
      <CardContent className="divide-y divide-border px-0">
        <div className="px-6 py-3 font-semibold text-muted-foreground text-xs uppercase tracking-wide">
          {t("farmersMarket.depositCard.deposit")} #{deposit.id} |{" "}
          {formatDepositDate(deposit.collection_time ?? deposit.backend_creation_time, {
            today: t("farmersMarket.depositCard.relativeDate.today"),
            yesterday: t("farmersMarket.depositCard.relativeDate.yesterday"),
          })}
        </div>

        {details.map(({ label, value }) => (
          <div key={label} className="flex items-center justify-between gap-4 px-6 py-3">
            <span className="text-muted-foreground text-sm">
              {t(`farmersMarket.details.columns.${label}`, {
                currency: currencySymbol,
                unit: unitCode,
              })}
            </span>
            <span className="font-medium text-foreground text-sm">{value}</span>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
